import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private router: Router,
    private translate: TranslateService,
    public afAuth: AngularFireAuth,
  ) {
    this.initializeApp();
    /**set Default Lang  Obligatoire pour que la traduction fonctionne */
    translate.addLangs(['en', 'fr']);
    const browserLang = this.translate.getBrowserLang();
    this.translate.setDefaultLang('fr');
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.initialize();
      /* this.router.navigateByUrl("tabs/tab1/list-user") */
      this.splashScreen.hide();
    });
  }

  ngOnInit() {}
  initialize() {
    // [START appcheck_initialize]
    const { initializeApp } = require('firebase/app');
    const {
      initializeAppCheck,
      ReCaptchaV3Provider,
    } = require('@firebase/app-check');

    const app = initializeApp({
      // Your firebase configuration object
    });

    // Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
    // key is the counterpart to the secret key you set in the Firebase console.
    const appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(
        '6Ldfm64jAAAAABLtfzEogG4n1tjMkL3zdTInYkMX',
      ),

      // Optional argument. If true, the SDK automatically refreshes App Check
      // tokens as needed.
      isTokenAutoRefreshEnabled: true,
    });
    // [END appcheck_initialize]
  }
}
